/**
 * admin-client-list-broadcast.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";
import { ChannelDetails } from "./clients-status-response";

/**
 * Admin channel details are an extension of the standard channel details that
 * provides a chat identifier as well as human-readable name for chatting with
 * admins.
 */
export interface AdminChannelDetails extends ChannelDetails
{
    chatId : number;
    user : string;
    userName : string;
}

/**
 * The {@link AdminClientListBroadcase} informs an admin panel session about
 * other clients that are also using the admin panel. The API is an analogue to
 * the usage of {@link AlgorithmUsersBroadcast} in its async updates of current
 * "collaborators".
 */
@validateFor(MessageTag.BCST_ADMIN_CLIENT_LIST)
export class AdminClientListBroadcast extends IncomingMessage
{
    /** The unique tag for this message type */
    public tag : MessageTag = MessageTag.BCST_ADMIN_CLIENT_LIST;

    /**
     * The id that had a change prompting this broadcast.
     * For the initial receipt, this will be the id of the current admin
     * (whose joining "triggered" the current broadcast).
     */
    @validateAs("string")
    public changedId : string;

    /**
     * The list of channels that are logged into admin sessions.
     */
    @validateAs({array: "object"}) // TODO better validation
    public adminChannels : AdminChannelDetails[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/admin-client-list-broadcast.ts